module.exports = __webpack_public_path__ + "static/assets/b02fab80f4bec1323ada5602bc86c1ee.svg";